module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////ljjjyy67srnv55tnvvZb12cT67OP88+zonl3nlkvqpm39+fb338/xxKL00rnttomIIvk4AAAAe0lEQVR4Xu3TOQ7DMBBD0SGpzc56/9PGEGykiGaKGO70KgEfxFSya02Jm+JmYiM3FwnIFgA4CjPrRE6p2hVaSQeOzuJrnNXdvLw/vMwuO/nw33qJbhNLtGZ8W1CwvgMluE2g+bmuUG98ZKw/+QnUfTr8hvllnaR3szOmD6kkAjgMYQ1+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_jan.png
// module id = 1688
// module chunks = 1